import React, { useState } from 'react';
import { FiX } from 'react-icons/fi';
import CyberMemorialService from '../../services/FamilyPlaza/CyberMemorialService';

const PortraitPhotoRegistrationModal = ({ isOpen, onClose, onConfirm, onPhotoUpload }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isUploading, setIsUploading] = useState(false);


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      // Create preview URL
      const url = URL.createObjectURL(file);
      setPreviewUrl(url);
    }
  };

  const handleConfirm = async () => {
    if (selectedFile) {
      setIsUploading(true);
      
      try {
        // Get goinId and goinName from localStorage
        const selectedPersonData = localStorage.getItem('selectedPersonData');
        if (!selectedPersonData) {
          setIsUploading(false);
          return;
        }

        const personData = JSON.parse(selectedPersonData);
        const { goinId, goinName } = personData;

        if (!goinId || !goinName) {
          setIsUploading(false);
          return;
        }

        // Create FormData with the image file
        const formData = new FormData();
        formData.append('file', selectedFile);

        // Call the new API
        const response = await CyberMemorialService.updateGoinProfileImage(goinId, goinName, formData);
        
        // Extract photo URL from response based on actual API response structure
        let photoUrl = null;
        if (response && response.photoUrl) {
          photoUrl = response.photoUrl;
        } else if (response && response.photoThumbUrl) {
          photoUrl = response.photoThumbUrl;
        } else if (response && response.data && response.data.photoUrl) {
          photoUrl = response.data.photoUrl;
        } else if (response && response.data && response.data.photoThumbUrl) {
          photoUrl = response.data.photoThumbUrl;
        }
        
        // If no photo URL in response, use the preview URL as fallback
        if (!photoUrl && previewUrl) {
          photoUrl = previewUrl;
        }
        
        // Call onConfirm after successful upload
        onConfirm();
         alert('이미지가 성공적으로 업로드되었습니다.');                              
         window.location.reload();       
      } catch (error) {
        console.error('Error updating profile image:', error);
        // You might want to show an error message to the user here
      } finally {
        setIsUploading(false);
      }
    } else {
      onConfirm();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="portrait-photo-registration-modal-overlay">
      <div className="portrait-photo-registration-modal">
        <div className="portrait-photo-registration-modal-header">
          <h2 className="portrait-photo-registration-modal-title">영정사진 등록하기</h2>
          <button className="portrait-photo-registration-modal-close" onClick={onClose}>
            <FiX />
          </button>
        </div>
        
        <div className="portrait-photo-registration-modal-content">
          <p className="portrait-photo-registration-modal-instruction">
            고인의 영정사진을 등록해 주세요
          </p>
          
          <div className="portrait-photo-registration-modal-file-input">
            <input
              type="file"
              id="portrait-photo-file"
              className="portrait-photo-registration-modal-file-input-hidden"
              onChange={handleFileChange}
              accept="image/*"
            />
            <label htmlFor="portrait-photo-file" className="portrait-photo-registration-modal-file-label">
              <span className="portrait-photo-registration-modal-file-text">파일을 선택해주세요.</span>
              <div className="portrait-photo-registration-modal-file-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 7V5C3 3.89543 3.89543 3 5 3H8.5L10.5 5H19C20.1046 5 21 5.89543 21 7V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V7Z" stroke="#666" strokeWidth="2" fill="none"/>
                  <circle cx="11" cy="11" r="3" stroke="#666" strokeWidth="2" fill="none"/>
                  <path d="M21 21L16.65 16.65" stroke="#666" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
            </label>
          </div>
          
          {previewUrl && (
            <div className="portrait-photo-registration-modal-preview">
              <img src={previewUrl} alt="Preview" />
            </div>
          )}
          
          <div className="portrait-photo-registration-modal-guideline">
            <span className="portrait-photo-registration-modal-bullet">•</span>
            <span>최적 사진 사이즈는 100x100px입니다.</span>
          </div>
        </div>
        
        <div className="portrait-photo-registration-modal-footer">
          <button className="portrait-photo-registration-modal-cancel-btn" onClick={onClose}>
            취소
          </button>
          <button 
            className="portrait-photo-registration-modal-register-btn" 
            onClick={(e) => {
              e.preventDefault();
              handleConfirm();
            }} 
            disabled={isUploading}
          >
            {isUploading ? '등록 중...': '등록'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PortraitPhotoRegistrationModal; 